import React from 'react';

//This is also a Stateless Functional Component
const NotFound = ()=>(
    <div>
        <h2>NOT FOUND!!!</h2>
    </div>
);

export default NotFound;